
import { DiscoveredUsFrom } from "@/models/discovered-us-from";
import { CompanyFilters } from "@/utils/company-filters";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		discoveredUsFrom: {
			type: Object as ()=>DiscoveredUsFrom,
		},
		filters: {
			type: Object as ()=>CompanyFilters
		},
		fancy: Boolean,
		label: String,
		emptyText: String
	},
	computed: {
		isFilter():boolean{
			if (this.filters){
				return true;
			}
			return false;
		},
		companyItems():ISelectItem<string>[]{
			return [
				{
					text: "Google",
					value: "google"
				},
				{
					text: "Facebook",
					value: "facebook"
				},
				{
					text: "Instagram",
					value: "instagram"
				},
				{
					text: "Andere sociale media",
					value: "otherSocialMedia"
				},
				{
					text: "Vriend of kennis",
					value: "friendOracquaintance"
				},
				{
					text: "Mijn boekhouder",
					value: "myAccountant"
				},
				{
					text: "Andere",
					value: "other"
				},
			];
		},
		filterItems():ISelectItem<string>[]{
			return [
				{
					text: "Google",
					value: "google"
				},
				{
					text: "Facebook",
					value: "facebook"
				},
				{
					text: "Instagram",
					value: "instagram"
				},
				{
					text: "Andere sociale media",
					value: "otherSocialMedia"
				},
				{
					text: "Vriend of kennis",
					value: "friendOracquaintance"
				},
				{
					text: "Mijn boekhouder",
					value: "myAccountant"
				},
				{
					text: "Andere",
					value: "other"
				},
				{
					text: "Niet ingevuld",
					value: "none"
				},
			];
		},
		items():ISelectItem<string>[]{
			if (this.isFilter){
				return this.filterItems;
			}
			return this.companyItems;
		},
		selectedFilterItems():string[]{
			let keys = Object.keys(this.filters.discoveredUsFrom);
			return keys.filter(k=>(this.filters.discoveredUsFrom as any)[k] as boolean);
		},
		selectedCompanyItems():string[]{
			let keys = Object.keys(this.discoveredUsFrom);
			return keys.filter(k=>{
				if (this.companyItems.find(i=>i.value == k) == null){
					return false;
				}
				return (this.discoveredUsFrom as any)[k] as boolean;
			});
		},
		selectedItems():string[]{
			if (this.isFilter){
				return this.selectedFilterItems;
			}
			return this.selectedCompanyItems;
		}
	},
	methods: {
		onDiscoveredUsFromInput(values:string[]){
			let keys = Object.keys(this.discoveredUsFrom);
			for (let key of keys) {
				(this.discoveredUsFrom as any)[key] = values.indexOf(key) != -1;
			}
		},
		onFiltersInput(values:string[]){
			let keys = Object.keys(this.filters.discoveredUsFrom);
			for (let key of keys) {
				(this.filters.discoveredUsFrom as any)[key] = values.indexOf(key) != -1;
			}
		},
		onInput(values:string[]){
			if (this.isFilter){
				this.onFiltersInput(values);
			}else{
				this.onDiscoveredUsFromInput(values);
			}
		}
	}
});
